import { Models } from '../../models/models';

export namespace EpicContextService {
    export function init() {
        const _window: any = window;
        _window.epicFunctions = {
            instance: instance,
            getParam: getParam,
            setParam: setParam,
            setParams: setParams,
            clear: clear,
        };
        if (_window.epicContext === null || _window.epicContext === undefined) {
            _window.epicContext = [{ key: 'init', value: 'empty' }];
        }
    }
    export function instance() {
        const _window: any = window;
        if (!_window.epicContext) {
            init();
        }
        return _window.epicContext;
    }
    export function functions() {
        const _window: any = window;
        if (!_window.epicContext) {
            init();
        }
        return _window.epicFunctions;
    }
    export function getParam(key: string): Models.IKeyValue<any> {
        return instance().find((v: Models.IKeyValue<any>) => {
            return v.key === key;
        });
    }

    export function setParam(key: string, value: any) {
        if (!getParam(key)) {
            instance().push({ key: key, value: value });
        } else {
            const param = getParam(key);
            param.value = value;
        }
    }

    export function setParams(params: Models.IKeyValue<any>[]) {
        params.map((p: Models.IKeyValue<any>) => {
            setParam(p.key, p.value);
        });
    }

    export function setParamsMobile(params: any[]) {
        const _window: any = window;
        const context: any[] = _window.epicContext;
        context.splice(0, context.length);
        for (let i = 0; i < params.length; i++) {
            context.push(params[i]);
        }
    }
    export function clear() {
        instance().splice(0, instance().length);
    }

    export interface IEpicFunctions {
        instance: () => any;
        getParam: (key: string) => any;
        setParam: (key: string, value: any) => any;
        setParams: (keyValues: Models.IKeyValue<any>[]) => any;
        clear: () => any;
    }
}
